import React, { useContext, useState } from "react";
import useVisible from "../../hooks/useVisible.jsx";
import CurrentUserContext from "../../contexts/CurrentUserContext.jsx";
import { getCachedScript } from "../../utils/scriptCache.js";
import handleClick from "../../utils/handleClick.js";
import "./VideoBolt.css";

function VideoBolt({
  selectedTag,
  buttonTags,
  generateButtonTags,
  closeComps,
}) {
  const currentUser = useContext(CurrentUserContext);
  const [isVisible, setIsVisible] = useVisible("VideoBoltVisibility");
  const [vbPointText, vbSetPointText] = useVisible("vbPointText");
  const [vbOpenComp, vbSetOpenComp] = useVisible("vbOpenComp");
  const [transparent, setTransparent] = useVisible("vbTransparent");
  const [createZip, setCreateZip] = useVisible("vbZip");
  const [posterFrameMs, setPosterFrameMs] = useState(false);
  const [isHover, setIsHover] = useState(false);

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i class="fa-regular fa-square-v"></i>
          <div />
        </div>
        <div className="button-card__title">Videobolt Tools</div>
        {generateButtonTags()}
      </li>
      <div
        className={`render-group ${isVisible ? "" : "render-group--hidden"}`}
      >
        {/* <div className="render-group__checkbox-group">
          <div className="render-group__checkbox">
            <input
              type="checkbox"
              id="vbPointText"
              checked={vbPointText}
              onChange={() => vbSetPointText(!vbPointText)}
              className="hidden-checkbox"
            />
            <label htmlFor="vbPointText">
              <span className="custom-checkbox"></span>
              <span className="label-text">Convert Point Text</span>
            </label>
          </div>
          <div className="render-group__checkbox">
            <input
              type="checkbox"
              id="vbOpenComp"
              checked={vbOpenComp}
              onChange={() => vbSetOpenComp(!vbOpenComp)}
              className="hidden-checkbox"
            />
            <label htmlFor="vbOpenComp">
              <span className="custom-checkbox"></span>
              <span className="label-text">Open Comp</span>
            </label>
          </div>
        </div> */}

        <div className="videobolt-tools">
          {currentUser.role === "admin" && (
            <div
              onClick={() =>
                handleClick(
                  "vbGlobalFitAndAlign",
                  JSON.stringify({
                    pointText: vbPointText,
                    openComp: vbOpenComp,
                  }),
                )
              }
              className="resolution-tools__button"
            >
              <i class="fa-sharp fa-regular fa-text-height"></i>
              <span>Fit and Align</span>
            </div>
          )}
          <div
            onClick={() => handleClick("capsDisable", false)}
            className="resolution-tools__button"
          >
            <i class="fa-regular fa-text-size"></i>
            <span>Caps Disable</span>
          </div>

          <div
            onClick={() => handleClick("vbCleanText", false)}
            className="resolution-tools__button"
          >
            <i class="fa-sharp fa-solid fa-text-slash"></i>
            <span>Text Clean</span>
          </div>
          <div
            onClick={() => handleClick("vbSortPlaceholders", false)}
            className="resolution-tools__button"
          >
            <i class="fa-light fa-folder-tree"></i>
            <span>Sort Placeholders</span>
          </div>
          <div
            onClick={() => handleClick("vbPlaceholdersRename", false)}
            className="resolution-tools__button"
          >
            <i class="fa-regular fa-image"></i>
            <span>Rename Placeholders</span>
          </div>
          <div
            onClick={() => handleClick("vbEffectsRename", false)}
            className="resolution-tools__button"
          >
            <i class="fa-regular fa-square-e"></i>
            <span>Rename Effects</span>
          </div>
          <div
            onClick={() => handleClick("vbCopyEffect", false)}
            className="resolution-tools__button"
          >
            <i class="fa-sharp fa-solid fa-copy"></i>
            <span>Copy Effect</span>
          </div>
        </div>

        <div className="render-group__checkbox-group mg-top">
          <input
            type="checkbox"
            id="vbTransparent"
            checked={transparent}
            onChange={() => setTransparent(!transparent)}
            className="hidden-checkbox"
          />
          <label htmlFor="vbTransparent">
            <span className="custom-checkbox"></span>
            <span className="label-text">Transparent</span>
          </label>
        </div>
        <div className="set-button">
          <div
            onClick={() =>
              window.jsx.evalScript(
                "app.project.activeItem.time.toFixed(2)",
                function (result) {
                  const value = Number(result);

                  if (Number.isFinite(value)) {
                    setPosterFrameMs(value);
                  } else {
                    console.warn("Result is not a number:", result);
                    setPosterFrameMs(false);
                  }
                },
              )
            }
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            className={`render-group__button ${
              posterFrameMs ? "set-button-active exp" : ""
            }`}
          >
            {posterFrameMs ? (
              <div>Poster Frame at Time: {posterFrameMs}</div>
            ) : (
              <>
                <i className="fa-sharp fa-light fa-image"></i>
                <span className="render-group__button-text">
                  {isHover ? "Set Poster Frame" : "Default Poster Frame"}
                </span>
              </>
            )}
          </div>
        </div>
        <div className="videobolt-tools">
          <div
            onClick={() => {
              handleClick("vbMetadata", {
                transparent: transparent,
                createZip: false,
                posterFrameMs: posterFrameMs,
              });
            }}
            className="resolution-tools__button"
          >
            <i class="fa-sharp-duotone fa-regular fa-arrow-down-to-line"></i>
            <span>Metadata File</span>
          </div>
          <div className="videobolt-tools">
            <div
              onClick={() => {
                handleClick("vbMetadata", {
                  transparent: transparent,
                  createZip: true,
                  posterFrameMs: posterFrameMs,
                });
              }}
              className="resolution-tools__button"
            >
              <i class="fa-sharp fa-light fa-file-zip"></i>
              <span>Metadata + Export Zip</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VideoBolt;
